<template>
    <div class="product-filter skip-latin-class" >
        <div v-if="isMobile" id="productHeader">
            <button class="accordion-toggle" data-toggle="collapse" data-target="#productList" aria-expanded="true" aria-controls="productList">
                <h3>
                    {{pointStore.products.Heading}} <span class="icon-arrow"></span>
                </h3>
            </button>
        </div>
        <h3 v-else>{{pointStore.products.Heading}}</h3>
        <div id="productList" :class="isMobile ? 'collapse in' : 'filter-open'" aria-labelledby="productHeader">
            <div class="product-list">
                <div class="product-type" :class="[product.Disabled ? 'disabled' : '', product.Selected ? 'selected' : '']" 
                v-on:click="toggleProduct(product)" v-for="product in pointStore.products.List" v-bind:key="product.Id">
                    <img :src="product.Image" :alt="product.Name"/>
                    <p>{{product.Name}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>  
    import { usePointStore } from '../store/store';
    const pointStore = usePointStore();

    const props = defineProps({
        products: Object,
        isMobile: Boolean
    });

    // props: {
    //     products: {
    //         type: Object
    //     },
    //     isMobile: {
    //         type: Boolean
    //     }
    // }
    
    const emit = defineEmits([
        'clicked',
        'toggleProduct'
    ]);
    
    function toggleProduct(product) {
        emit('clicked', product);
        emit('toggleProduct', product);
    }
    

</script>